import { productIdZodSchema } from "@@/shared/products/product-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateWordSlug } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import z from "zod";
import { orderItemIdZodSchema } from "../../../order-items/order-item-id";
import { signatureFactory } from "../../signature-factory";
import type { _OrderEventBaseFactoryParams } from "../_order-base.event";
import {
    _orderEventBaseFactory,
    _orderEventBaseZodObject,
} from "../_order-base.event";

const orderItemProductHasAccessEventZodObject = _orderEventBaseZodObject.merge(
    z.object({
        providerId: providerIdZodSchema,
        orderItemId: orderItemIdZodSchema,
        productId: productIdZodSchema,
        type: z.literal("ORDER_ITEM_PRODUCT_HAS_ACCESS"),
    }),
);
type OrderItemProductHasAccessEvent = z.infer<
    typeof orderItemProductHasAccessEventZodObject
>;
const orderItemProductHasAccessEventZodSchema =
    orderItemProductHasAccessEventZodObject as z.ZodSchema<OrderItemProductHasAccessEvent>;

type FactoryParams = _OrderEventBaseFactoryParams &
    Except<
        OrderItemProductHasAccessEvent,
        "type" | "_id" | "_type" | "_createdAt" | "signature"
    >;
type Params = Except<FactoryParams, "signature">;

const orderItemProductHasAccessEventFactory = (
    params: Params,
): OrderItemProductHasAccessEvent => {
    return {
        ..._orderEventBaseFactory({
            orderId: params.orderId,
            orderGroupId: params.orderGroupId,
            _version: params._version,

            providerId: params.providerId,
            providerSlug: params.providerSlug,

            signature: signatureFactory(
                params.orderId,
                "ORDER_ITEM_PRODUCT_HAS_ACCESS",
                [generateWordSlug()],
            ),
        }),
        type: "ORDER_ITEM_PRODUCT_HAS_ACCESS",

        providerId: params.providerId,
        orderItemId: params.orderItemId,
        productId: params.productId,
    };
};

const isOrderItemProductHasAccessEvent = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    event: any,
): event is OrderItemProductHasAccessEvent => {
    return (
        event._type === "ORDER_EVENT" &&
        event.type === "ORDER_ITEM_PRODUCT_HAS_ACCESS"
    );
};

export {
    isOrderItemProductHasAccessEvent,
    orderItemProductHasAccessEventFactory,
    orderItemProductHasAccessEventZodObject,
    orderItemProductHasAccessEventZodSchema,
};
export type { OrderItemProductHasAccessEvent };
